import "./ConditionTreatment.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import TheReality from "./sections/TheReality";
import CommonProblemsWeFix from "./sections/CommonProblemsWeFix";
import LaminateDetails from "./sections/LaminateDetails";
import GuidesAndNews from "./sections/GuidesAndNews";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import WhoWeHelp from "./sections/WhoWeHelp";
import BookingCallToAction from "./sections/BookingCallToAction";
import Fertilityacupunctureclinical from "./sections/Fertilityacupunctureclinical";
import Footer from "@/reusable_sections/Footer";
export default function ConditionTreatmentPage() {
  return <div>
      <Header />
      <Hero />
      <TheReality />
      <CommonProblemsWeFix />
      <LaminateDetails />
      <GuidesAndNews />
      <FrequentlyAskedQuestions />
      <WhoWeHelp />
      <Fertilityacupunctureclinical />
      <BookingCallToAction />
      <Footer />
    </div>;
}